export default __webpack_public_path__ + "static/media/Bank-documentation.217d9bde.md";